import { createSelector, createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface ViewAsUser {
  id: string
  name: string
  username: string
}

export interface ViewAsState {
  target: ViewAsUser | null
}

const viewAsSlice = createSlice({
  name: 'viewAs',
  initialState: { target: null } as ViewAsState,
  reducers: {
    startViewingAs: (state, { payload }: PayloadAction<ViewAsUser>) => {
      state.target = payload
    },
    stopViewingAs: (state) => {
      state.target = null
    }
  },
  selectors: {
    viewAsUserSelector: createSelector(
      (state: ViewAsState) => state.target,
      (target) => target
    ),
    viewAsUserIdSelector: createSelector(
      (state: ViewAsState) => state.target?.id,
      (targetId) => targetId
    )
  }
})

export const { startViewingAs, stopViewingAs } = viewAsSlice.actions
export const { viewAsUserSelector, viewAsUserIdSelector } = viewAsSlice.selectors
export default viewAsSlice
